/**
 * @name track
 * @function
 * @param {string} type The name of the direct call event to execute
 * @param {Object} payload Additional variable information required by the event (hash and PST Id are included by default)
 * @description Dispatches a direct call event to Adobe DTM
 */
export const track = ( type, payload={} ) => ({
    type,
    meta: {
        report: { 
            type,
            payload
        }
    }
});